export function getFacetRequests(state) {
    return Object.values(state).map((slice) => slice.request);
}
